<div class="modal-container">
  <suite-rfb-collapse [title]="titulo" [collapsed]="false">
    <via-dados-basicos-pj [dadosBasicos]="this.dadosBasicos" [cnpj]="this.cnpj">
    </via-dados-basicos-pj>
  </suite-rfb-collapse>
</div>
